import apiClient from "../config/apiClient";


export const fetchRadiology = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=requests/${id}/request/portal/scans?page=1%26limit=10%26startDate=%26endDate=%26item_id=undefined%26type=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
